import React from 'react';
import theme from '../../theme';

// Pill row: one button per option, `active` is the selected index.
function ToggleSwitch({ onToggle, options, active }) {
  return (
    <div className={`inline-flex p-1 text-sm leading-none ${theme.pillContainer}`}>
      {options.map((label, index) => (
        <button
          key={label}
          type="button"
          onClick={() => onToggle(index)}
          className={`inline-flex items-center rounded-lg px-4 py-2 text-sm font-medium transition-all duration-200 ${
            index === active ? theme.pillActive : theme.pillInactive
          }`}
        >
          {label}
        </button>
      ))}
    </div>
  );
}

export default ToggleSwitch;
